import Store from "App/Store.js";

export default args => Store.dispatch({type: "args", args});
